module.exports = __webpack_public_path__ + "img/arrow-green-up.e876f0c3.svg";